// (function () {
//   var KEY = 'shipofz_wishlist';

//   function get() {
//     try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
//   }
//   function save(list) {
//     try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
//   }
//   function toggle(handle) {
//     var list = get();
//     var i = list.indexOf(handle);
//     if (i > -1) list.splice(i, 1); else list.push(handle);
//     save(list);
//     refresh();
//   }

//   function refresh() {
//     var list = get();
//     document.querySelectorAll('.wishlist-count').forEach(function (el) {
//       var text = String(list.length);
//       if (el.textContent !== text) el.textContent = text;
//       el.hidden = list.length === 0;
//     });
//     document.querySelectorAll('.wishlist-btn').forEach(function (b) {
//       var on = list.indexOf(b.dataset.handle) > -1;
//       b.classList.toggle('is-active', on);
//       b.setAttribute('aria-pressed', on ? 'true' : 'false');
//     });
//   }

//   function renderPage() {
//     var grid = document.getElementById('wishlist-grid');
//     if (!grid) return;
//     var list = get();
//     if (!list.length) {
//       grid.innerHTML = '<p>Your wishlist is empty.</p>';
//       return;
//     }
//     var fmt = new Intl.NumberFormat(undefined, {
//       style: 'currency',
//       currency: grid.dataset.currency || 'USD'
//     });
//     Promise.all(list.map(function (h) {
//       return fetch('/products/' + h + '.js')
//         .then(function (r) { return r.ok ? r.json() : null; })
//         .catch(function () { return null; });
//     })).then(function (products) {
//       var html = '';
//       products.forEach(function (p) {
//         if (!p) return;
//         var img = p.featured_image ? p.featured_image.split('?')[0] + '?width=500' : '';
//         var price = fmt.format(p.price / 100);
//         var compare = p.compare_at_price > p.price
//           ? ' <s>' + fmt.format(p.compare_at_price / 100) + '</s>' : '';
//         html += '<div class="wishlist-item">' +
//           '<a href="' + p.url + '">' +
//           (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
//           '<h3>' + p.title + '</h3></a>' +
//           '<p>' + price + compare + '</p>' +
//           '<button type="button" class="button button--secondary wishlist-remove" data-remove="' + p.handle + '">Remove</button>' +
//           '</div>';
//       });
//       grid.innerHTML = html || '<p>Your wishlist is empty.</p>';
//     });
//   }

//   document.addEventListener('click', function (e) {
//     var heart = e.target.closest('.wishlist-btn');
//     if (heart) {
//       e.preventDefault();
//       e.stopPropagation();
//       toggle(heart.dataset.handle);
//       return;
//     }
//     var rm = e.target.closest('.wishlist-remove');
//     if (rm) {
//       toggle(rm.dataset.remove);
//       renderPage();
//     }
//   });

//   var timer;
//   new MutationObserver(function () {
//     clearTimeout(timer);
//     timer = setTimeout(refresh, 100);
//   }).observe(document.body, { childList: true, subtree: true });

//   document.addEventListener('DOMContentLoaded', function () {
//     refresh();
//     renderPage();
//   });
// })();

(function () {
  var KEY = 'shipofz_wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HEART = '<svg viewBox="0 0 24 24" stroke-linejoin="round"><path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.5-9.5 9-9.5 9z"/></svg>';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function refresh() {
    var list = get();
    var n = list.length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      var t = String(n);
      if (el.textContent !== t) el.textContent = t;
      el.hidden = n === 0;
    });
    document.querySelectorAll('.wishlist-btn').forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-total]').forEach(function (el) {
      var t = n === 0 ? 'Nothing saved yet' : n + (n === 1 ? ' item saved' : ' items saved');
      if (el.textContent !== t) el.textContent = t;
    });
    document.querySelectorAll('[data-wishlist-clear]').forEach(function (b) {
      b.hidden = n === 0;
    });
  }

  function renderEmpty(grid) {
    grid.innerHTML =
      '<div class="wl-empty">' + HEART +
      '<h2>Your wishlist is empty</h2>' +
      '<p>Tap the heart on any product to save it here.</p>' +
      '<a class="wl-cta" href="' + esc(grid.dataset.shopUrl || '/collections/all') + '">Continue shopping</a>' +
      '</div>';
  }

  function syncPage() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var list = get();
    grid.querySelectorAll('.wl-item').forEach(function (el) {
      if (list.indexOf(el.dataset.handle) === -1) el.remove();
    });
    if (!grid.querySelector('.wl-item')) renderEmpty(grid);
  }

  function toggle(handle) {
    var list = get();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    save(list);
    refresh();
    syncPage();
  }

  function card(p, fmt) {
    var img = p.featured_image ? String(p.featured_image).split('?')[0] + '?width=600' : '';
    var url = root + 'products/' + p.handle;
    var off = p.compare_at_price > p.price
      ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var compare = off ? '<s>' + fmt.format(p.compare_at_price / 100) + '</s>' : '';
    var cta = p.available
      ? '<a class="wl-cta" href="' + url + '">View product</a>'
      : '<span class="wl-cta" aria-disabled="true">Sold out</span>';

    return '<article class="wl-item" data-handle="' + esc(p.handle) + '">' +
      '<div class="wl-item__media">' +
        '<a href="' + url + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<button type="button" class="wishlist-btn is-active" data-handle="' + esc(p.handle) +
          '" aria-pressed="true" aria-label="Remove from wishlist">' + HEART + '</button>' +
        (off ? '<span class="wl-item__badge">' + off + '% off</span>' : '') +
      '</div>' +
      '<div class="wl-item__body">' +
        '<h3 class="wl-item__title"><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
        '<div class="wl-item__price"><strong>' + fmt.format(p.price / 100) + '</strong>' + compare + '</div>' +
        '<div class="wl-item__cta">' + cta + '</div>' +
      '</div>' +
    '</article>';
  }

  function renderPage() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var list = get();
    if (!list.length) { renderEmpty(grid); return; }

   var sk = '';
var skCount = Math.min(list.length, 8);
for (var i = 0; i < skCount; i++) {
  sk += '<div class="wl-sk-card">' +
          '<div class="fl-sk fl-sk--img">' + (window.FUSS_INF || '') + '</div>' +
          '<div class="wl-sk-txt"><i></i><i></i><i></i></div>' +
        '</div>';
}
grid.innerHTML = sk;

    var fmt = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: grid.dataset.currency || 'USD'
    });

    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) {
          if (r.status === 404) return { gone: true };
          return r.ok ? r.json() : null;
        })
        .catch(function () { return null; });
    })).then(function (items) {
      var keep = list.filter(function (h, i) { return !(items[i] && items[i].gone); });
      if (keep.length !== list.length) { save(keep); refresh(); }

      var html = items
        .filter(function (p) { return p && !p.gone; })
        .map(function (p) { return card(p, fmt); })
        .join('');

      if (html) grid.innerHTML = html;
      else if (!keep.length) renderEmpty(grid);
      else grid.innerHTML = '<p class="wl-loading">Couldn’t load your items. Please refresh the page.</p>';
    });
  }

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('.wishlist-btn');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      toggle(heart.dataset.handle);
      return;
    }
    if (e.target.closest('[data-wishlist-clear]')) {
      save([]);
      refresh();
      syncPage();
    }
  });

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(refresh, 100);
  }).observe(document.body, { childList: true, subtree: true });

  function init() { refresh(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();